// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31ZPI","footer":"Form_footer__1YiCb"};